import { ApiResult } from '@api/core/ApiResult';
import { ApiError } from '@api/index';

type BodyWithError = { errors?: any[] };

export const normalizeApiErrors = <T>(responseBody: T) => {
  const body = responseBody as BodyWithError;
  if (body?.errors?.length) {
    throw new ApiError({ body } as ApiResult, body.errors?.[0].title);
  }
  return (body ?? {}) as T;
};
